<template>
  <div class="hello">

  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    created() {
      this.$router.push('/')
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/jump.vue